export default "__VITE_ASSET__tqZy$Pem__"